import firebase from 'firebase'
export class State {
  onLine: boolean = navigator.onLine

  user: firebase.User | null = null
}
